/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFarmerAccount } from '../../../azure-b2c/storage';
import TitleBox from '../../../../components/TitleBox';
import { Button, Stack } from '@mui/material';
import TestIds from '../../../../testIds';

export interface ActivitiesHeaderProps {
  onCreateActivity: () => void;
}

const ActivitiesHeader: FC<ActivitiesHeaderProps> = ({ onCreateActivity }): JSX.Element => {
  const account = useSelector(selectCurrentFarmerAccount);

  return (
    <Stack
      top={0}
      mb={2}
      gap={{ xs: 2, sm: 1 }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent='space-between'
    >
      <TitleBox
        display='Activities'
        subheading={`Manage upcoming Activities for ${account?.accountName}`}
        subheadingProps={{ variant: 'h6', color: 'text.primary', pt: 1 }}
      />
      <Stack>
        <Button
          variant='contained'
          onClick={onCreateActivity}
          data-testid={TestIds.feat.activities.header.newActivityButton}
        >
          New Activity
        </Button>
      </Stack>
    </Stack>
  );
};

export default ActivitiesHeader;
